import { render, staticRenderFns } from "./AnnouncementsShow.vue?vue&type=template&id=7cd48fde&"
import script from "./AnnouncementsShow.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsShow.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementsShow.vue?vue&type=style&index=0&id=7cd48fde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports